<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  action?: () => void;
  needDark?: boolean;
}>();
</script>

<template>
  <button
    class="flex h-[36px] items-center rounded-4 px-[12px] hover:bg-gray-150 active:bg-gray-250"
    :class="{ 'dark:hover:bg-gray-750 dark:active:bg-gray-800': props.needDark }"
    role="menuitem"
    @click="() => props.action && props.action()"
  >
    <slot></slot>
  </button>
</template>
